<template>
  <div id="statsPayment">
    <div class="container">

      <Panel class="Configurations" :title="$t('parameters')" collapsible>
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{ $t('start') }}</label>
              <datetime v-model="filters.start" value-zone="local" input-id="p_start" input-style="width: 100%"
                :max-datetime="filters.end" />
            </div>
            <div class="group">
              <label>{{ $t('end') }}</label>
              <datetime v-model="filters.end" value-zone="local" input-id="p_end" input-style="width: 100%"
                :min-datetime="filters.start" />
            </div>
          </div>
          <div class="column">
            <div class="group">
              <label>{{ $t('statistics.param.processor') }}</label>
              <select v-model="filters.processor">
                <option :value="undefined">{{ $t('all') }}</option>
                <option v-for="p of processors" :value="p" :key="`pr_${p}`">{{ p }}</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t('statistics.param.liveMode') }}</label>
              <select v-model="filters.liveMode">
                <option :value="undefined"></option>
                <option :value="1">{{ $t('yes') }}</option>
                <option :value="0">{{ $t('no') }}</option>
              </select>
            </div>
          </div>

        </div>
        <button class="btn btn-primary" @click="generate">{{ $t('generate') }}</button>
      </Panel>

      <Panel ref="dataTab" v-if="tableData" :title="$t('result')">
        <RawTable v-if="tableData" :columns="tableData.columns" :rows="tableData.rows"
          :key-value-header="tableData.query" />
      </Panel>

    </div>
  </div>
</template>

<script>
  import RawTable from '@/components/RawTable.vue';
  import moment from "moment-timezone";
  import { Core } from "@/core/Core";

  export default {
    name: "StatsPayment",

    components: { RawTable },

    data() {
      return {
        processors: [
          'cybersource',
          'data_candy_loyalty',
          'data_candy_prepaid',
          'e_wallet',
          'evo',
          'free_bees_loyalty',
          'free_bees_prepaid',
          'global',
          'ishop_prepaid',
          'itc',
          'none',
          'optimal',
          'payfacto',
          'paysafe',
          'stripe',
          'worldpay'
        ],
        filters: {
          start: moment().toISOString(),
          end: moment().toISOString(),
          processor: undefined,
          liveMode: 1
        },
        tableData: null
      }
    },

    methods: {
      async generate() {
        let query = JSON.parse(JSON.stringify(this.filters))
        query.start = query.start.substring(0, 10).concat(' 00:00:00');
        query.end = query.end.substring(0, 10).concat(' 23:59:59');
        this.$store.commit('showSpinner', true);
        this.tableData = await Core.request("GET", '/api/payment_data', query);
        this.tableData.query = query;
        this.$store.commit('showSpinner', false);
        setTimeout(() => {
          this.$refs.tabs.setActive(this.$refs.dataTab);
        }, 0);
      }
    }
  }
</script>